/* eslint-disable */
import React, { Component } from 'react'
import { CheckBox } from 'react-native-elements'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { ScrollView, Text, KeyboardAvoidingView, TextInput, View, Platform, Keyboard } from 'react-native'
import { connect } from 'react-redux'
import RoundedButton from "../Components/RoundedButton"
import InputCell from '../Components/InputCell'
import BadgeButton from '../Components/BadgeButton'
import ProfilePhotoCell from '../Components/ProfilePhotoCell'
import ProfilePhoto from '../Components/ProfilePhoto'
import Spacer from '../Components/Spacer'
import TextareaCell from '../Components/TextAreaCell'
import TermsCell from '../Components/TermsCell'
import SignUpActions from '../Redux/SignUpRedux'

import NavigationBar from "../Components/NavigationBar"
import TextInputComponent from "../Components/TextInputComponent"
import SlideButton from "../Components/SlideButton"
import {
  TERMURL,
} from '../Constant';
import styles from './Styles/SignUpScreenStyle'
import { validateSignUp } from '../Components/ValidateComponent';
import FooterButton from '../Components/FooterButton';
import { Field, reduxForm, startSubmit } from 'redux-form';
import BaseScreen from './BaseScreen';
import I18n from "i18n-js"

class SignUpScreen extends Component {

  static navigationOptions = {
    header: null,

  }
  constructor(props) {
    super(props);
    this.state = {
      bio: null,
      email: null,
      firstName: null,
      lastName: null,
      password: null,
      passwordAgain: null,
      phone: null,
      photo: null,
      termsOfUseAccepted: false, // TODO UI
      username: null,

    };
  }

  signUp = (values) => {
    if (this.state.password !== this.state.passwordAgain)
      alert('\n\nYour passwords didn’t match')
    else {
      Keyboard.dismiss()
      this.props.navigation.dispatch(startSubmit('SignupForm'))
      return new Promise((resolve, reject) => {
        this.props.signup({ ...values, resolve, reject })
      });
    }
  }
  componentDidMount() {
    this.navigationBar.setLeftNavBarButtons([
      { onPress: this.onBackPress, type: 'back' },
    ])
  }
  onBackPress = () => {
    this.props.navigation.goBack()
  }
  isFilled = () =>
    !!(
      this.state.username &&
      this.state.email &&
      this.state.password &&
      this.state.passwordAgain &&
      this.state.termsOfUseAccepted
    )

  onTermAndConditionPress = () => {
    this.props.navigation.navigate('WebViewScreen', { title: 'Terms and Conditions', url: TERMURL });

  }
  keyboardAccessory = () => (
    <FooterButton
      disabled={!this.isFilled() || this.props.submitting}
      onPress={this.props.handleSubmit(this.signUp)}
      style={styles.footerButton}
      title={`Sign Me Up`}
    />
  )
  render() {
    const { photo } = this.state
    const { submitting, handleSubmit } = this.props
    return (
      <BaseScreen
        keyboardAccessory={this.keyboardAccessory()}
        showKeyboardAccessory={!!this.isFilled()}
        loading={submitting}>
        <NavigationBar
          ref={(view) => {
            if (view) this.navigationBar = view
          }}
          title={`Register`}
        />
        <KeyboardAwareScrollView
        extraScrollHeight = {120}
         style={styles.container}>

          <Field name="username"
            separator
            autoCapitalize="none"
            autoCorrect={false}
            onChange={(text) => {
              this.setState({ username: text.replace(/\s/g, "_") })
            }}
            placeholder={I18n.t('signUp.minCharacter')}
            newValue = {this.state.username}
            title={I18n.t('login.username')}
            value={this.state.username}
            component={InputCell}
          />

          <Field name="email"
            separator
            autoCapitalize="none"
            autoCorrect={false}
            keyboardType="email-address"
            onChange={(text) => {
              this.setState({ email: text })
            }}
            placeholder={I18n.t('signUp.domain')}

            title={I18n.t('signUp.email')}
            value={this.state.email}
            component={InputCell} />

          <Field name="password"
            separator
            autoCorrect={false}
            onChange={(text) => {
              this.setState({ password: text })
            }}
            placeholder={`8 digits, 1 capital, lower, and num`}
            secure={true}

            title={I18n.t('login.password')}
            value={this.state.password}
            component={InputCell} />
          <Spacer />

          <Field name="confirmPassword"
            separator
            autoCorrect={false}
            onChange={(text) => {
              this.setState({ passwordAgain: text })
            }}
            placeholder={`8 digits, 1 capital, lower, and num`}
            secure={true}

            title={`Password again`}
            value={this.state.passwordAgain}
            component={InputCell} />
          <Spacer />

          <View style={styles.term}>
            <CheckBox
              checkedColor={`black`}
              onIconPress={() => this.setState({
                termsOfUseAccepted: !this.state.termsOfUseAccepted
              })}
              style={styles.checkbox}
              checked={this.state.termsOfUseAccepted}
            />
            <TermsCell onLinkPress={this.onTermAndConditionPress} />
          </View>

          <Field name="firstName"
            separator
            autoCapitalize="words"
            autoCorrect={false}
            onChange={(text) => {
              this.setState({ firstName: text })
            }}
            placeholder={`First`}

            title={`First name`}
            value={this.state.firstName}

            component={InputCell}
          />
          <Field name="lastName"

            separator
            autoCapitalize="words"
            autoCorrect={false}
            onChange={(text) => {
              this.setState({ lastName: text })
            }}
            placeholder={`Last`}

            title={`Last name`}
            value={this.state.lastName}
            component={InputCell}
          />
          <Field name="phone"
            separator
            autoCapitalize="none"
            autoCorrect={false}
            keyboardType="phone-pad"
            onChange={(text) => {
              this.setState({ phone: text })
            }}
            placeholder={`(000) 000-0000`}

            title={I18n.t('signUp.phoneNumber')}
            value={this.state.phone}
            component={InputCell}
          />
          <Field name="bio"
            autoCorrect={true}
            onChange={(text) => {
              this.setState({ bio: text })
            }}
            placeholder={`You're Awesome - What's your super power?`}

            title={`About you`}
            value={this.state.bio}
            component={TextareaCell}
          />

        </KeyboardAwareScrollView>
        <View style={{ marginVertical: 0 }}>
          <FooterButton
            disabled={!this.isFilled() || submitting}
            onPress={handleSubmit(this.signUp)}
            style={styles.footerButton}
            title={`Sign Me Up`}
          />
        </View>
      </BaseScreen>
    )
  }
}
// get sucess , fetching state from store
const mapStateToProps = (state) => {
  return {
    success: state.signup.success,
    fetching: state.signup.fetching
  }
}

const mapDispatchToProps = (dispatch) => ({
  signup: (values) => dispatch(SignUpActions.signupRequest(values))
})
const SignupForm = reduxForm({
  form: 'SignupForm',
  validate: validateSignUp
})(SignUpScreen)
export default connect(mapStateToProps, mapDispatchToProps)(SignupForm)
